import type { BoardRow } from '../types/board';

export type CovenantCounts = BoardRow['covenants'];

/** F-LR-065: a waived or indeterminate test is not a pass, so "5 pass" never hides a waived breach. */
export const covenantLabel = (c: CovenantCounts) => {
  if (c.breaches) return `${c.breaches} breach`;
  const parts = [`${c.passes ?? c.tests - (c.waived ?? 0) - (c.indeterminate ?? 0)} pass`];
  if (c.waived) parts.push(`${c.waived} waived`);
  if (c.indeterminate) parts.push(`${c.indeterminate} not determinable`);
  return parts.join(' · ');
};
export const covenantTone = (c: CovenantCounts) => c.breaches ? 'critical' as const : c.waived || c.indeterminate ? 'warning' as const : 'done' as const;
